import SummaryTranslationParamMapper from "../../core/service/translations/SummaryTranslationParamMapper";
import { parseBooleanValue } from "../../util";
import { ICaseLawDocument } from "../model/CaseLawDocument";

const CaseLawDocumentParamMapper = (item: ICaseLawDocument) => {
  return {
    id: item.id ?? undefined,
    summary: item.summary,
    status: item.status,
    searchId: item.searchId,
    documentTypeId: item.documentTypeId,
    organisationId: item.organisationId,
    notes: item.notes,
    valid: parseBooleanValue(item.valid),
    summaryTranslations: (item.summaryTranslations || []).map((item) =>
      SummaryTranslationParamMapper(item)
    ),
    caseLawDocDate:
      item.caseLawDocDate instanceof Date
        ? item.caseLawDocDate?.getTime()
        : item.caseLawDocDate
  };
};

export default CaseLawDocumentParamMapper;
